import { render, staticRenderFns } from "./esgManagement.vue?vue&type=template&id=0820e67e"
import script from "./esgManagement.vue?vue&type=script&lang=js"
export * from "./esgManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0820e67e')) {
      api.createRecord('0820e67e', component.options)
    } else {
      api.reload('0820e67e', component.options)
    }
    module.hot.accept("./esgManagement.vue?vue&type=template&id=0820e67e", function () {
      api.rerender('0820e67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/esg/esgManagement.vue"
export default component.exports